import React from "react";

import { DotcomApp, SpecialOffersPlacement } from "@swa-ui/dotcom";
import { InflightRetryProvider, WifiAuthenticationProvider } from "@swa-ui/inflight";

import { maintenanceCodes } from "../../defines/maintenanceCodes";
import { InflightUserStatusProvider } from "../../providers";
import { AccountLoginCallToActionCommand } from "../AccountLoginCallToActionCommand";
import { EnrollCallToActionCommand } from "../EnrollCallToActionCommand";
import { InflightHomePageContainer } from "../InflightHomePageContainer";
import { SpecialOffersSection } from "../SpecialOffersSection";
import { ThanksToTMobileBanner } from "../ThanksToTMobileBanner";

const basePath = "/inflight/home-page";

export const App = () => {
  return (
    <DotcomApp {...getDotcomAppProps()}>
      <WifiAuthenticationProvider>
        <InflightRetryProvider>
          <InflightUserStatusProvider>
            <InflightHomePageContainer />
          </InflightUserStatusProvider>
        </InflightRetryProvider>
      </WifiAuthenticationProvider>
    </DotcomApp>
  );

  function getDotcomAppProps() {
    return {
      appId: "inflight-home-page",
      appPlacementComponents: {
        "card-list": SpecialOffersSection,
        "special-offer": SpecialOffersPlacement,
        "thanks-to-t-mobile-banner": ThanksToTMobileBanner,
      },
      basePath,
      chapi: "inflight-portal",
      chapiVersion: "v1",
      defaultAppSettings: {
        default: {
          disableMetadataCall: true,
          flightDataTtlMinutes: 5,
          flightTrackerPollingInterval: 60000,
          inflightRetryCount: 2,
          inflightRetryDelay: 1000,
          placementsPageContextRequired: true,
          suppressUserInfo: true,
          themeMode: "dark",
        },
      },
      maintenanceCodes,
      placementsConfig: {
        configuredCommands: {
          HOME_PAGE_ACCOUNT_LOGIN: AccountLoginCallToActionCommand,
          HOME_PAGE_ENROLL: EnrollCallToActionCommand,
        },
      },
    };
  }
};
